/* eslint-disable */
// @ts-nocheck
import { ReduxAsyncAction } from '../support/utils';
import dash_api from '../support/dash_api';
import { ReduxActionNames } from '../types/utilTypes';

// This action is handled in the individual SAN Partner Reducers
const GetAdAccountStatus = new ReduxAsyncAction('SAN_PARTNERS_GET_AD_ACCOUNT_STATUS');
GetAdAccountStatus.registerRequest(({ ad_network, lookback_days = 7 }) => {
  const params = ad_network ? { params: { ad_network, lookback_days } } : {};
  return dash_api.get(`/v1/zeit-query/ad-account-status/`, params).then((res) => {
    return res.data;
  });
});

export const GET_AD_ACCOUNT_STATUS: ReduxActionNames = GetAdAccountStatus.constants;
export const getAdAccountStatus = GetAdAccountStatus.request;
